var requestIdCounter = 0;

var OriginalRequest = Request;

var Request = function(url, data, override) {
  if (url.includes('/img/d/3d') || url.includes('draco_decoder.js')) {
    return new OriginalRequest(url, data);
  }
  this.url = url;
  this.data = data;
  this._type = 'post';
  this._cache = false;
  this._context = null;
  this._successFunction = null; // API response success
  this._afterSuccessDialogFunction = null; // After API response success
  this._afterWarningDialogFunction = null;
  this._afterWarningCancelDialogFunction = null;
  this._errorFunction = null; // API response error
  this._afterErrorDialogFunction = null; // After API response error
  this._failureFunction = null; // API connection error
  this.getXHR = false;
  this.xhr = null;
  this._useRequestId = false;
  this._hasLoader = false;
  this.loading = new Loading();
  this.override = override || false;
  this._completeFunction = null;
  this.contentType = 'application/x-www-form-urlencoded; charset=UTF-8';
  this.processData = true;
  this._dontHideLoaderOnSuccess = false;
  this.noApiErrorPopup = false;
  this.shouldReloadPageOnLoginSuccess = false;

  this.success = function(f) {
    this._successFunction = f;
    return this;
  };

  this.error = function(f) {
    this._errorFunction = f;
    return this;
  };

  this.afterSuccessDialogFunction = function(f) {
    this._afterSuccessDialogFunction = f;
    return this;
  };

  this.afterWarningDialogFunction = function(f) {
    this._afterWarningDialogFunction = f;
    return this;
  };

  this.afterWarningCancelDialogFunction = function(f) {
    this._afterWarningCancelDialogFunction = f;
    return this;
  };

  this.afterErrorDialogFunction = function(f) {
    this._afterErrorDialogFunction = f;
    return this;
  };

  this.failure = function(f) {
    this._failureFunction = f;
    return this;
  };

  this.complete = function(f) {
    this._completeFunction = f;
    return this;
  }

  this.useRequestId = function(b) {
    this._useRequestId = b;
    return this;
  };

  this.type = function(t) {
    this._type = t;
    return this;
  }

  this.cache = function(b) {
    this._cache = b;
    return this;
  }

  this.context = function(c) {
    this._context = c;
    return this;
  };

  this.setContentType = function(v) {
    this.contentType = v;
    return this;
  };

  this.setProcessData = function(v) {
    this.processData = v;
    return this;
  };

  this.dontHideLoaderOnSuccess = function(b) {
    this._dontHideLoaderOnSuccess = b;
    return this;
  };

  this.setShouldReloadPageOnLoginSuccess = function(v) {
    this.shouldReloadPageOnLoginSuccess = v;
    return this;
  };

  this.call = function(ignoreWarning) {
    ignoreWarning = ignoreWarning || false
    this._hasLoader = true;
    this.showLoader();
    this.send(ignoreWarning);
  };

  this.send = function(ignoreWarning) {
    this.data['ignoreWarning'] = ignoreWarning;
    this.data['device'] = 'D';
    var accountIdParam = getAccountIdParam();
    if (accountIdParam) {
      this.data['accountId'] = accountIdParam;
    }

    if (this._useRequestId) {
      this.data['requestId'] = ++requestIdCounter;
    }

    // If FormData is used use append
    if (this.data instanceof FormData) {
      this.data.append('ignoreWarning', ignoreWarning);
      this.data.append('device', 'D');

      if (accountIdParam) {
        this.data['accountId'] = accountIdParam;
      }

      if (this._useRequestId) {
        this.data['requestId'] = ++requestIdCounter;
      }
    }

    if (this._type === 'get' || this._type === 'delete') {
      console.log(this.data);
      console.log(this.url);
      var sep = '?';
      if (this.url.indexOf('?') > -1) {
        sep = '&';
      }

      for (var m in this.data) {
        if (m !== 'ignoreWarning' && m !== 'device' && m !== '_') {
          this.url += sep + m + '=' + encodeURI(this.data[m]);
          sep = '&';
        }
      }

      console.log(this.url);

      this.data = {};
    }

    var xhr = $.ajax({
      cache: this._cache,
      url: this.url,
      type: this._type,
      dataType: 'json',
      data: this.data,
      context: this,
      contentType: this.contentType,
      processData: this.processData,
      xhrFields: {
        withCredentials: true
      },
      crossDomain: true,
      beforeSend: function(req) {
        req.setRequestHeader("requestId", uuidv4());
      },
      success: function(json) {
        var _this = this;
        var _json = json;

        if (_this._useRequestId) {
          if (requestIdCounter != json.requestId) {
            if (_this._hasLoader) {
              _this.hideLoader();
            }
            console.log("requestId mismatch (" + _this.url + "): " + requestIdCounter + " vs " + json.requestId);
            return;
          }
        }

        // Error
        if (json.error) {
          if (_this._hasLoader) {
            _this.hideLoader();
          }

          // Go to due diligence extra page
          if (typeof json.pendingDueDiligenceHighRisk !== 'undefined' && json.pendingDueDiligenceHighRisk) {
            var title = json.title.length > 0 ? json.title : 'BullionStar Account Verification';
            var message = json.message.length > 0 ? json.message : getDueDiligencePopupString();

            var options = {
              title: title,
              message: message,
              okCallback: function() {
                window.location.href = '/verification1';
              },
              cancel: true,
              cancelCallback: function() {
                if (!isLoggedIn()) {
                  window.location.reload();
                }
              }
            };
            var popup = new Popup(options);
            popup.render();

            return;
          }

          // Show due diligence popup
          if (typeof json.pendingDueDiligence !== 'undefined' && json.pendingDueDiligence) {
            var options = {
              title: 'BullionStar Account Verification',
              message: getDueDiligencePopupString(),
              okCallback: function() {
                window.location.href = '/verification';
              },
              cancel: true
            };
            var popup = new Popup(options);
            popup.render();

            return;
          }

          // Override popup showing error message
          // Used in order confirmation page
          if ('accessAllowed' in json && !json.accessAllowed) {
            if (_this._errorFunction != null) {
              _this._errorFunction(json);
            }

            return;
          }

          if (json.title.length > 0 && json.message.length > 0) {
            if (_this._errorFunction != null) {
              _this._errorFunction(json);
              return;
            }
            if (_this._afterErrorDialogFunction != null) {
              var options = {
                title: json.title,
                message: json.message,
                okCallback: function() {
                  _this._afterErrorDialogFunction(_json);
                }
              };
              var popup = new Popup(options);
              popup.render();
            } else {
              var popup = new Popup({
                title: json.title,
                message: json.message
              });
              popup.render();
            }
          }

          if (_this._errorFunction != null) {
            _this._errorFunction(json);
          }
          // Warning
        } else if (json.warning) {
          if (json.warning && !ignoreWarning) {

            var options = {
              title: json.title,
              message: json.message,
              okCallback: function() {
                if (_this._afterWarningDialogFunction != null) {
                  console.log('OK CALLBACK TRIGGERED')
                  _this._afterWarningDialogFunction(json);
                }
              },
              cancel: true,
              cancelCallback: function() {
                console.log('CANCEL CALLBACK TRIGGERED')
                if (_this._afterWarningCancelDialogFunction != null) {
                  _this._afterWarningCancelDialogFunction(json);
                }
              },
            };

            var popup = new Popup(options);
            popup.render();

            if (json.buttonTextOverride) {
              $('.backdrop2 .popup .buttons .ok').text('Place Order');
            }
          }

          if (_this._hasLoader) {
            _this.hideLoader();
          }
          // Authentication Required
        } else if (json.authenticationRequired) {
          if (_this._hasLoader) {
            _this.hideLoader();
          }

          // Override popup showing error message
          // Used in order confirmation page
          if ('accessAllowed' in json && json.accessAllowed) {
            if (_this._errorFunction != null) {
              _this._errorFunction(json);
            }
            return;
          }

          var showPopupLogin = function() {
            console.log('Showing login popup');
            // Close all opened popup
            $('.btn-close-popup').click();

            var options = {
              redirectOnClose: true
            }
            if (this.shouldReloadPageOnLoginSuccess) {
              options.shouldReloadPageOnLoginSuccess = true;
            }
            var login = new PopupLogin(options);
            login.render();
          };

          if (json.title.length > 0 && json.message.length > 0) { // Chain popups if any message.
            var options = {
              title: json.title,
              message: json.message,
              okCallback: showPopupLogin
            };

            var popup = new Popup(options);
            popup.render();
          } else {
            showPopupLogin();
          }


        } else if (json?.status && json.status === 10) {
          if (_this._hasLoader) {
            _this.hideLoader();
          }

          var showCaptcha = function() {
            var options = {
              title: 'Human Verification Required',
              message: 'Please input the numbers seen below to proceed.',
              ca: json.ca,
              csvg: json.csvg,
              okCallback: function(answer) {
                _this.data['challengeAnswer'] = answer;
                _this.data['ca'] = json.ca;
                _this.call();
              },
            };

            var popup = new PopupCaptcha(options);
            popup.render();
          };

          if (json.title.length > 0 && json.message.length > 0) { // Chain popups if any message.
            var options = {
              title: json.title,
              message: json.message,
              okCallback: showCaptcha
            };

            var popup = new Popup(options);
            popup.render();
          } else {
            showCaptcha();
          }
        } else if (json?.status && json.status === 11) {
          if (_this._hasLoader) {
            _this.hideLoader();
          }

          var showCaptcha = function() {
            var options = {
              title: 'Human Verification Required',
              message: 'Please click the checkbox and follow the prompt.',
              okCallback: function(answer) {
                _this.data['challengeAnswer'] = answer;
                _this.data['ca'] = json.ca;
                _this.call();
              },
            };

            var popup = new PopupHCaptcha(options);
            popup.render();
          };

          if (json.title.length > 0 && json.message.length > 0) { // Chain popups if any message.
            var options = {
              title: json.title,
              message: json.message,
              okCallback: showCaptcha
            };

            var popup = new Popup(options);
            popup.render();
          } else {
            showCaptcha();
          }
          // Success
        } else {
          if (_this._hasLoader && !_this._dontHideLoaderOnSuccess) {
            _this.hideLoader();
          }

          if (json.title.length > 0 && json.message.length > 0) {

            if (this.override) {
              if (_this._successFunction != null) {
                _this._successFunction(json, _this._context);
              }
              return;
            }

            var options = {
              title: json.title,
              message: json.message
            };

            if (this._afterSuccessDialogFunction != null) {
              options.okCallback = function() {
                _this._afterSuccessDialogFunction(json);
              }
            }
            var popup = new Popup(options);
            popup.render();
          }

          if (_this._successFunction != null) {
            _this._successFunction(json, _this._context);
          }
        }
      },
      error: function(json) {
        var _this = this;

        if (_this._hasLoader) {
          _this.hideLoader();
        }

        if (json.statusText === 'abort') {
          console.log('Don\'t freak out. User Aborted!');
          return;
        }

        console.log('API connection error');

        if (!_this.getXHR) {}

        if (_this._failureFunction != null) {
          _this._failureFunction();
        } else {
          // if(!_this.noApiErrorPopup) {
          //   var message = 'We regret that this page could not load. Please try again. If the problem persists, please <a href="/contact">contact us</a>.';
          //   var popup = new Popup({ title: 'Connection Timeout', message: message });
          //   popup.render();
          // }
        }
      },
      complete: function(json) {
        var _this = this;
        if (_this._completeFunction != null) {
          _this._completeFunction(json);
        }
      }
    });

    if (this.getXHR) {
      this.xhr = xhr;
    }
  };

  this.showLoader = function() {
    this.loading.render();
  };

  this.hideLoader = function() {
    this.loading.close();
  };
}